import type { ReactNode, SyntheticEvent } from 'react';

/**
 * A closed row that opens in place (mockup *Signature in the Portal*, parent
 * row): the title, a one-line summary in the words the part inside already
 * uses, and what is inside unchanged. A native <details>, so it opens from the
 * keyboard and a screen reader says whether it is open.
 */
export function Disclosure(props: {
  title: string;
  summary?: ReactNode;
  children: ReactNode;
  /** Open when first drawn; the parent can still close it. */
  open?: boolean;
  onToggle?: (event: SyntheticEvent<HTMLDetailsElement>) => void;
}) {
  return (
    <details className="disclosure" open={props.open} onToggle={props.onToggle}>
      <summary>
        <span className="hour-row-text">
          <span className="name">{props.title}</span>
          {props.summary ? <span className="detail">{props.summary}</span> : null}
        </span>
        <span className="disclosure-mark" aria-hidden="true" />
      </summary>
      <div className="disclosure-body">{props.children}</div>
    </details>
  );
}
